import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@material-ui/core';

import { formSchema } from './form-schema';
import { useStyles } from './styles';

import * as session from '../../utils/session';
import CustomButton from '../../components/CustomButton/CustomButton';
import CustomInputForm from '../../components/CustomInputForm/CustomInputForm';
import {
  CONFIRMACAO_FIELDS,
  CONFIRMACAO_LABELS,
  CONFIRMACAO_TXTS,
} from '../../consts/text/confirmacao-seguranca';
import { AutenticationActions } from '../../store/ducks/autentication';
import ReactGTM from '../../utils/gtm';
import { getTipoPessoaFromDocument } from '../../utils/normalizers/normalizers';


export default function FormConfirmacaoSeguranca({ isPrimeiroAcesso }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState, setValue } = useForm({
    resolver: yupResolver(formSchema),
  });
  const { errors } = formState;

  const isChatbot = session.getChatbot();
  const tagId = isChatbot
    ? 'salvar-codigo-acesso-whats-001'
    : 'salvar-codigo-acesso-001';

  const onSubmit = (data) => {
    if (isPrimeiroAcesso) {
      const userName = session.getUserNamePrimeiroAcesso();
      dispatch(
        AutenticationActions.postValidarTokenPrimeiroAcessoRequest({
          cpfCnpj: userName,
          token: data[CONFIRMACAO_FIELDS.CODIGO_ACESSO],
          tipoPessoa: getTipoPessoaFromDocument(userName),
        }),
      );
    } else {
      dispatch(
        AutenticationActions.postValidarTokenRequest({
          userName: session.getUserName(),
          token: data[CONFIRMACAO_FIELDS.CODIGO_ACESSO],
        }),
      );
    }
  };

  const onErrorForm = (err) => {
    //* * Google Analytics */
    ReactGTM.eventErrorsForm(err);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrorForm)}>
      <Grid item xs={12} container>
        <Grid item xs={12}>
          <CustomInputForm
            inputRef={register}
            customClass={classes.input}
            errors={errors}
            setValueForm={setValue}
            label={CONFIRMACAO_LABELS.CODIGO_ACESSO}
            name={CONFIRMACAO_FIELDS.CODIGO_ACESSO}
            data-gtm-form="input"
            data-gtm-name="codigo-de-acesso"
          />
        </Grid>
        <Grid item xs={12}>
          <CustomButton
            className={classes.button}
            content={CONFIRMACAO_TXTS.BUTTON}
            variant="contained"
            type="submit"
            gtm={{
              id: tagId,
              'data-gtm-name': 'salvar',
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
}
